<template>
  <div class="register_container">
    <div class="login_box">
      <div class="avatar_box">
        <img src="../assets/logo3.png" />
      </div>
      <el-form
        ref="loginFormRef"
        :model="user"
        :rules="loginFormRules"
        class="login_form"
        label-width="100px"
      >
        <el-form-item prop="loginName" label="用户名">
          <el-input
            placeholder="请输入用户名"
            v-model="user.loginName"
          ></el-input>
        </el-form-item>
        <el-form-item prop="passwprd" label="密码">
          <el-input
            placeholder="请输入密码"
            v-model="user.passwprd"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enterpriseName" label="企业名称">
          <el-autocomplete
            placeholder="请输入企业名称"
            v-model="user.enterpriseName"
            style="width: 320px"
            clearable
            :fetch-suggestions="querySearchAsync"
            @select="handleSelect"
            @clear="setBlur"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item prop="enterpriseCreditCode" label="企业信用代码">
          <el-input
            placeholder="请输入企业信用代码"
            v-model="user.enterpriseCreditCode"
          ></el-input>
        </el-form-item>
        <el-form-item prop="juridicalPerson" label="企业法人">
          <el-input
            placeholder="请输入企业法人"
            v-model="user.juridicalPerson"
          ></el-input>
        </el-form-item>
        <el-form-item prop="categoryStr" label="所属行业">
          <el-input
            placeholder="请输入所属行业"
            v-model="user.categoryStr"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enterpriseAddress" label="企业详细地址">
          <el-input
            placeholder="请输入企业详细地址"
            v-model="user.enterpriseAddress"
          ></el-input>
        </el-form-item>
        <el-form-item class="login_button">
          <el-button type="primary" @click="register">注 册</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <div>主办单位：德阳市住房和城乡建设局</div>
      <div>运营及技术单位: 德阳发展集团 卓远征信</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        loginName: "",
        passwprd: "",
        enterpriseName: "",
      },
      loginFormRules: {
        loginName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 3,
            max: 10,
            message: "长度在 3 到 10 个字符",
            trigger: "blur",
          },
        ],
        passwprd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 5,
            max: 18,
            message: "长度在 5 到 18 个字符",
            trigger: "blur",
          },
        ],
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
      },
      restaurants: [],
    };
  },
  methods: {
    // input搜索请求接口 querySearch参数名 cb回调函数
    async querySearchAsync(querySearch, cb) {
      if (querySearch && querySearch.length > 0) {
        try {
          const { data: res } = await this.$http.post(
            `http://129.211.214.215:8080/qycx/qycx?qymc=${encodeURIComponent(querySearch)}&page=1&pagesize=20`
          );

          this.restaurants = res.data;

          if (this.restaurants.length == 0) {
            this.restaurants.push({
              id: "-1",
              value: "无匹配结果",
            });
            cb(this.restaurants);
          } else {
            let list = this.restaurants.map((item) => {
              return {
                value: `${item.name}`,
                creditcode: `${item.creditCode}`,
                regLocation: `${item.regLocation}`,
                legalPersonName: `${item.legalPersonName}`,
                categoryStr: `${item.categoryStr}`,
              };
            });
            cb(list);
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    // 监听输入框搜索的数据
    handleSelect(item) {
      console.log(item);
      this.user.enterpriseCreditCode = item.creditcode;
      this.user.juridicalPerson = item.legalPersonName;
      this.user.categoryStr = item.categoryStr;
      this.user.enterpriseAddress = item.regLocation;
    },
    setBlur() {
      //  在点击由 clearable 属性生成的清空按钮时，主动触发失去焦点，解决‘fetch-suggestions’输入建议不提示的bug
      document.activeElement.blur();
      this.user.enterpriseCreditCode = "";
      this.user.juridicalPerson = "";
      this.user.categoryStr = ""; 
      this.user.enterpriseAddress = "";
    },

    register() {
 
      if (this.user.loginName == '') {
        this.$message.info('请输入账号');
        return
      }

      if (this.user.passwprd == '') {
        this.$message.info('请输入密码');
        return
      }

      if (this.user.enterpriseName == '') {
        this.$message.info('请输入企业名称');
        return
      }

      if (this.user.enterpriseCreditCode == '') {
        this.$message.info('请输入企业企业信用代码');
        return
      }

      if (this.user.juridicalPerson == '') {
        this.$message.info('请输入企业法人信息');
        return
      }

      if (this.user.categoryStr == '') {
        this.$message.info('请输入所属行业');
        return
      }

      if (this.user.enterpriseAddress == '') {
        this.$message.info('请输入企业详细地址');
        return
      }
      
      this.$refs.loginFormRef.validate(async (valid) => {
        const { data: res } = await this.$http.post(
          "register/register",
          this.user
        );
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.$router.push("/");
      });
    },
  },
};
</script>

<style lang="scss">
.register_container {
  background-image: url("../assets/backkground.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;

  .footer{
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .login_title {
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translate(-50%, -50%);
    color: #666;
    font-size: 20px;
    font-weight: 600;
  }

  .login_box {
    width: 480px;
    height: 560px;
    border-radius: 3px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.avatar_box {
  width: 80px;
  height: 80px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
}
.avatar_box img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #eee;
}
.login_form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
}

.login_button {
  display: flex;
  justify-content: end;
}
</style>
